/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["table[_ngcontent-%COMP%]{width:100%}.mat-form-field[_ngcontent-%COMP%]{font-size:14px;width:100%}.mat-select-panel-wrap[_ngcontent-%COMP%]{padding-top:30px!important}\n/*# sourceMappingURL=user.component.css.map*/"];
export { styles as styles };
